var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.modules),function(c,index){return _c('boxModule',{key:'module-'+index,attrs:{"title":c.title,"description":c.description,"icon":c.icon,"description-padding":_vm.descriptionPadding}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }